module.exports = __webpack_public_path__ + "img/cookie.04d5833e.png";